import { z } from "zod";

export const DiscountAppDtoSchema = z.object({
  id: z.string(),
  appId: z.string(),
  discountId: z.string().nullish(),
  experienceId: z.string().nullish(),
  appType: z.string(),
});

export type DiscountAppDto = z.infer<typeof DiscountAppDtoSchema>;
